import { lookup } from 'node:dns/promises';
import type { ResolveHostname } from '../types';

export async function withTimeout<T>(promise: Promise<T>, timeoutMs: number): Promise<T> {
  let timer: NodeJS.Timeout | undefined;
  const timeout = new Promise<never>((_resolve, reject) => {
    timer = setTimeout(() => {
      const error = new Error('timeout');
      error.name = 'TimeoutError';
      reject(error);
    }, timeoutMs);
  });

  try {
    return await Promise.race([promise, timeout]);
  } finally {
    if (timer) clearTimeout(timer);
  }
}

export function createDnsResolver(timeoutMs: number): ResolveHostname {
  return async (hostname) => {
    const records = await withTimeout(lookup(hostname, { all: true, verbatim: true }), timeoutMs);
    return records.slice(0, 16).map((record) => ({
      address: record.address,
      family: record.family === 6 ? 6 : 4,
    }));
  };
}
